<template>
  <div :style="{'background-image': containerBackground}" class="outer-container">
    <div ref="container" v-show="!loading" class="inner-container">
    </div>
  </div>
</template>

<script>
import * as THREE from 'three'
import vrml from '@/VRMLLoader'
import controls from '@/ViewerControls'

const VRMLLoader = vrml(THREE)
const ViewerControls = controls(THREE)

export default {
  name: 'ModelViewer',
  data () {
    return {
      loading: false,
      animating: false
    }
  },
  props: ['fallbackImage', 'modelUrl'],
  methods: {
    init () {
      this.camera = new THREE.PerspectiveCamera(60, this.$refs.container.clientWidth / this.$refs.container.clientHeight, 0.01, 1e10)
      window.camera = this.camera
      this.camera.position.z = 0.6
      this.controls = new ViewerControls(null, this.$refs.container)
      this.controls.autoRotateSpeed = SETTINGS.modelSpinSpeed
      this.scene = new THREE.Scene()
      this.scene.background = new THREE.Color(0x000000)
      this.scene.add(this.camera)
      // light
      let light = new THREE.DirectionalLight(0xababbb, 0.3)
      light.position.set(-30, 100, 1).normalize()
      this.camera.add(light)
      light = new THREE.DirectionalLight(0xbbabab, 0.3)
      light.position.set(10, -200, -3).normalize()
      this.camera.add(light)
      light = new THREE.HemisphereLight(0xababbb, 0x404040, 1)
      this.scene.add(light)
      // loader
      this.loader = new VRMLLoader()
      // renderer
      this.renderer = new THREE.WebGLRenderer({ antialias: false })
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.setSize(this.$refs.container.clientWidth, this.$refs.container.clientHeight)
      this.$refs.container.appendChild(this.renderer.domElement)
      //
      window.addEventListener('resize', () => this.resize(), false)
    },
    animate () {
      if (this.animating === true) {
        requestAnimationFrame(this.animate)
        this.controls.update()
        this.renderer.render(this.scene, this.camera)
      }
    },
    loadModel (model) {
      if (this.loadedModel) {
        this.scene.remove(this.pivot)
      }
      this.loadedModel = this.loader.parse(model)
      // this.scene.add(this.loadedModel)

      new THREE.Box3().setFromObject(this.loadedModel).getCenter(this.loadedModel.position)
      this.loadedModel.position.multiplyScalar(-1)
      this.pivot = new THREE.Group()
      this.scene.add(this.pivot)
      this.pivot.add(this.loadedModel)
      this.controls.setTarget(this.pivot)
    },
    resize () {
      this.camera.aspect = this.$refs.container.clientWidth / this.$refs.container.clientHeight
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.$refs.container.clientWidth, this.$refs.container.clientHeight)
      // TODO: zoom in/out to fit object
    },
    load (url) {
      if (typeof url === 'string') {
        fetch(url)
          .then(data => data.text())
          .then(vrml => {
            this.loadModel(vrml)
            this.loading = false
            let interval = window.setInterval(() => {
              let canvas = this.$refs.container.querySelector('canvas')
              if (canvas !== null && canvas.width === 0) {
                this.resize()
              } else {
                window.clearInterval(interval)
              }
            }, 100)
            this.animating = true
            this.animate()
            this.spin()
          })
      }
      this.loading = true
      this.animating = false
    },
    zoomin () {
      this.camera.position.z /= 1.1
    },
    zoomout () {
      this.camera.position.z *= 1.1
    },
    spin () {
      this.controls.autoRotate()
    }
  },
  mounted () {
    this.init()
    this.load(this.modelUrl)
    window.viewer = this
  },
  computed: {
    containerBackground () {
      return 'url(' + this.fallbackImage + ')'
    }
  },
  watch: {
    modelUrl (url) {
      this.load(url)
    }
  }
}

</script>

<style scoped>
.inner-container {
  height: 100%;
  width: 100%;
}

.outer-container {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ModelViewer.vue